import React, { Component } from "react";
import "./navbar.css";
import { Nav, NavItem } from "reactstrap";
import { NavLink } from "react-router-dom";

import Shoppingcartimage from "../../Images/shopping-cart.svg";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.state = { scrolling: false };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll(event) {
    if (window.scrollY < 200 && this.state.scrolling === true) {
      this.setState({ scrolling: false });
    } else if (window.scrollY >= 200 && this.state.scrolling !== true) {
      this.setState({ scrolling: true });
    }
  }

  render() {
    return (
      <div className={this.state.scrolling ? "Navbar sticky-navbar" : "Navbar"}>
        <Nav className="Nav-container">
          <div className="Nav-items">

            <NavItem>
              <NavLink exact activeClassName="selected" to="/">
                <div className="Header-title-container">
                  <h3 className="header-title"> Jenee's Home Furnishings </h3>
                </div>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink exact activeClassName="selected" to="/shop">
                Shop
              </NavLink>
            </NavItem>
          </div>
          <NavItem>
            <div
              className="
          Nav-shoppingcart"
            >
              <img
                className="Nav-image"
                src={Shoppingcartimage}
                alt="Shopping cart"
                height="32"
                width="32"
              ></img>
              <NavLink exact activeClassName="selected" to="/shoppingcart">
                Shoppingcart
              </NavLink>
            </div>
          </NavItem>
        </Nav>
      </div>
    );
  }
}

export default Navbar;
